const globalConfig = {
     /* 生产
      serverUrl: "https://business.dongkuntech.cn/api/v1",
      localUrl: 'https://ads.dongkuntech.cn',*/

     /* 测试
      serverUrl: 'https://test-api.dongkuntech.cn/api/v1',
      localUrl: 'http://localhost:3000',*/

      // 本地：后端跑在 docker 里的 127.0.0.1:8000
      serverUrl: process.env.VUE_APP_SERVER_URL || 'http://127.0.0.1:8000/api/v1',
      localUrl: process.env.VUE_APP_LOCAL_URL || 'http://localhost:3001',
}
export default globalConfig
